<template>
  <UiCard class="poll_wrapper">
    <div slot="title">
      <div class="title">Анкета</div>
    </div>

    <div slot="content">
      <span v-if="!poll">Анкета не заполнена.</span>
      <div v-else>
        <UiCardContentLine v-for="(p, i) in poll" :key="i" class="card_content_line" mode="сolumn">
          <span slot="title">{{ p.title }}</span>
          <span slot="value"> {{ p.value }} </span>
        </UiCardContentLine>
      </div>
    </div>
  </UiCard>
</template>

<script>
import UiCard from '@/components/card/UiCard.vue'
import UiCardContentLine from '@/components/card/UiCardContentLine.vue'

import currentApplicationMixin from './mixins/currentApplicationMixin'

import getValue from '@/components/table/helpers/getValue'

export default {
  components: { UiCard, UiCardContentLine },
  mixins: [currentApplicationMixin],
  computed: {
    poll() {
      if (!this.$currentApp) return
      if (!this.$currentApp.polls) return null

      return [
        {
          title: 'Номер телефона',
          value: getValue(this.$currentApp, 'phone'),
        },
        {
          title: 'Название организации',
          value: getValue(this.$currentApp.polls, 'organization_name'),
        },
        {
          title: 'Сфера деятельности',
          value: getValue(this.$currentApp.polls, 'area'),
        },
        {
          title: 'Размер клиентской базы',
          value: getValue(this.$currentApp.polls, 'client_base'),
        },
        {
          title: 'Программа лояльности',
          value: getValue(this.$currentApp.polls, 'Другое'),
        },
        {
          title: 'CRM-система, online-касса',
          value: getValue(this.$currentApp.polls, 'crm'),
        },
        {
          title: 'Количество пластиковых карт',
          value: getValue(this.$currentApp.polls, 'number_of_cards'),
        },
        {
          title: 'Задачи',
          value: getValue(this.$currentApp.polls, 'goals'),
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.poll_wrapper {
  margin: 0 0 30px 0;
}
</style>
